import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import MessageModal from '../container/MessageModal';
import TextControl from '../container/customizedInputs/TextControl';
import TextAreaControl from '../container/customizedInputs/TextAreaControl';
import LabelControl from '../container/customizedInputs/LabelControl';
import SelectControl from '../container/customizedInputs/SelectControl';
import { errorClassification } from '../errorHandler';
import usuariosServices from '../services/usuariosServices';

const UsuarioForm = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [usuario, setUsuario] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [roles, setRoles] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);
  const [saving, setSaving] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };


  let { id } = useParams();

  useEffect(() => {
    setEsNuevo( id === undefined )

    obtenerProvincias()

    if(id){
      fetchUsuario(id)
    } else {
      nuevoUsuario()
    }
  }, [id]);

  useEffect(() => {
    if( authInformation.autenticado === true && authInformation.rol === 'Admin' ){
      obtenerRoles()
    }
  }, [authInformation]);


  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && ((authInformation.rol === 'Admin' || authInformation.user_id === usuario.id))){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }

  }, [authInformation, usuario]);


  const fetchUsuario = async (id) => {
    try {
      const data = await usuariosServices.obtenerUsuarioPorId(id);
      setUsuario(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const nuevoUsuario = async () => {
    try {
      const data = await usuariosServices.nuevoUsuario();
      setUsuario(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const obtenerRoles = async () => {
    try {
      const data = await usuariosServices.obtenerRoles();
      setRoles(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const obtenerProvincias = async () => {
    try {
      const data = await usuariosServices.obtenerProvincias();
      setProvincias(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };


  const guardarUsuario = async () => {
    try {
      setSaving(true)
      let data;
      const copiaUsuario = {...usuario}
      copiaUsuario.preferencias_usuario_attributes = copiaUsuario.preferencias_usuario
      delete copiaUsuario.preferencias_usuario

      if(esNuevo){
        data = await usuariosServices.crearUsuario({usuario: copiaUsuario});
      } else {
        data = await usuariosServices.actualizarUsuario(copiaUsuario.id, {usuario: copiaUsuario});
      }

      setUsuario(data);
      setSaving(false)
      if (authInformation.user_id === data.id){
        setAuthInformation({...authInformation,
          nombre: data.nombre
        })
      }

      alert("Datos actualizados")
      // navigate(`/listaUsuarios`);

    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      // usado para valores anidados
      const [parentKey, childKey] = name.split('.');
      setUsuario((usuario) => ({
        ...usuario,
        [parentKey]: {
          ...usuario[parentKey],
          [childKey]: value,
        },
      }));
    } else {
      setUsuario({...usuario,
        [name]: value
      })
    }
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setUsuario({...usuario,
      [name]: files[0]
    })
  };

  const handleFormSubmit = (e) => {
    e.preventDefault()

    guardarUsuario()
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            {/* <pre>{JSON.stringify(usuario, null, 2)}</pre> */}
            <form>
            {
              usuario.activo === false && (
                <div className="alert alert-danger" role="alert">
                  Esta cuenta no está activada, aún.
                </div>
              )
            }
            {
                authInformation.rol === 'Admin' && (
                  <>
                    <div className="card mb-3">
                      <div className="card-body">
                        <h5 className="card-title">Rol</h5>
                        <div className="mb-3">
                          <SelectControl
                            value={usuario.rol}
                            options={roles}
                            name={'rol'}
                            handleInput={handleInput}
                            label={'Seleccione el rol'}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )
              }
              <div className='row mb-3'>
                <div className='col-sm-6'>
                  <TextControl
                    value={usuario.nombre}
                    name={'nombre'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={usuario.apellido}
                    name={'apellido'}
                    handleInput={handleInput}
                    />
                </div>
              </div>

              <div className='row mb-3'>
                <div className='col-sm-6'>
                  <TextControl
                    value={usuario.documento_identidad}
                    name={'documento_identidad'}
                    handleInput={handleInput}
                    />
                </div>
                <div className='col-sm-6'>
                  <TextControl
                    value={usuario.preferencias_usuario && usuario.preferencias_usuario.cuil}
                    name={'preferencias_usuario.cuil'}
                    handleInput={handleInput}
                    />
                </div>
              </div>

              <div className='row mb-3'>
                <div className='col-sm-6'>
                  {
                    (authInformation.autenticado === true && authInformation.rol === 'Admin') ? (
                      <TextControl
                        value={usuario.email}
                        name={'email'}
                        handleInput={handleInput}
                        type={'email'}
                        />
                    ) : (
                      <LabelControl 
                        value={usuario.email}
                        label={'Email'}
                      />
                    )
                  }

                </div>
              </div>

              {
                esNuevo && (
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="card-title">Ingrese su clave</h5>
                      <div className='row mb-3'>
                        <div className='col-sm-6'>
                          <TextControl
                            value={usuario.password}
                            name={'password'}
                            handleInput={handleInput}
                            type='password'
                            label='Clave'
                            />
                        </div>
                        <div className='col-sm-6'>
                         <TextControl
                            value={usuario.password_confirmation}
                            name={'password_confirmation'}
                            handleInput={handleInput}
                            type='password'
                            label='Repita la clave'
                            />
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

              <div className="card mb-3">
                <div className="card-body">
                <h5 className="card-title">Suba su foto</h5>

                {
                  usuario.imageUrl && (
                    <img src={usuario.imageUrl} className="img-fluid" alt={usuario.nombre} />
                  )
                }

                <div className="mb-3">
                  <input placeholder="Adjunte su foto" className="form-control" onChange={handleFileChange} name="foto" type="file" id="foto" />
                </div>

                </div>
              </div>

              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title mb-3">Datos personales</h5>

                  <div className='row mb-3'>
                    <div className='col-sm-6'>
                    <TextControl
                        className='mb-3'
                        value={usuario.preferencias_usuario && usuario.preferencias_usuario.domicilio}
                        name={'preferencias_usuario.domicilio'}
                        handleInput={handleInput}
                      />
                    </div>
                    <div className='col-sm-6'>
                      <SelectControl
                        value={usuario.preferencias_usuario && usuario.preferencias_usuario.provincia_id}
                        options={provincias}
                        name={'preferencias_usuario.provincia_id'}
                        handleInput={handleInput}
                        label={'Seleccione una Provincia'}
                      />
                    </div>
                    <div className='col-sm-6'>
                      <TextControl
                        className='mb-3'
                        value={usuario.preferencias_usuario && usuario.preferencias_usuario.ciudad}
                        name={'preferencias_usuario.ciudad'}
                        handleInput={handleInput}
                      />
                    </div>
                    <div className='col-sm-6'>
                      <TextControl
                        className='mb-3'
                        value={usuario.preferencias_usuario && usuario.preferencias_usuario.codigo_postal}
                        name={'preferencias_usuario.codigo_postal'}
                        handleInput={handleInput}
                        label={'Código Postal'}
                      />
                    </div>
                  </div>
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="card-title">Teléfonos</h5>
                        <div className='row mb-3'>
                          <div className='col-sm-6'>
                            <TextControl
                              className='mb-3'
                              value={usuario.preferencias_usuario && usuario.preferencias_usuario.telefono_movil}
                              name={'preferencias_usuario.telefono_movil'}
                              handleInput={handleInput}
                            />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              className='mb-3'
                              value={usuario.preferencias_usuario && usuario.preferencias_usuario.telefono_fijo}
                              name={'preferencias_usuario.telefono_fijo'}
                              handleInput={handleInput}
                            />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              className='mb-3'
                              value={usuario.preferencias_usuario && usuario.preferencias_usuario.telefono_laboral}
                              name={'preferencias_usuario.telefono_laboral'}
                              handleInput={handleInput}
                            />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              className='mb-3'
                              value={usuario.preferencias_usuario && usuario.preferencias_usuario.fax}
                              name={'preferencias_usuario.fax'}
                              handleInput={handleInput}
                            />
                          </div>
                        </div>
                      </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-sm-12'>
                      <TextAreaControl
                          value={usuario.preferencias_usuario && usuario.preferencias_usuario.observaciones}
                          name={'preferencias_usuario.observaciones'}
                          handleInput={handleInput}
                        />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button disabled={saving} className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">
                  {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                  <span role="status">Guardar</span>
                </button>

                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>

            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default UsuarioForm;